export const UPDATE_SOCIAL_SECURITY_DATA = 'UPDATE_SOCIAL_SECURITY_DATA';
export const MODEL_SOCIAL_SECURITY_SCENARIO = 'MODEL_SOCIAL_SECURITY_SCENARIO';
export const UPDATE_SOCIAL_SECURITY_ERROR = 'UPDATE_SOCIAL_SECURITY_ERROR';
export const SET_INITIAL_STATE_FOR_SOCIAL_SECURITY = 'SET_INITIAL_STATE_FOR_SOCIAL_SECURITY';

export const updateSocialSecurityData = (data: Array<Record<string, any>>) => ({
  type: UPDATE_SOCIAL_SECURITY_DATA,
  payload: data,
});

export const modelSocialSecurityScenario = () => ({
  type: MODEL_SOCIAL_SECURITY_SCENARIO,
});

export const updateSocialSecurityError = (data: Array<Record<string, any>>) => ({
  type: UPDATE_SOCIAL_SECURITY_ERROR,
  payload: data,
});

export const setInitialStateForSocialSecurity = (data: any) => ({
  type: SET_INITIAL_STATE_FOR_SOCIAL_SECURITY,
  payload: data,
});
